import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SelectHotelTemplateQuery } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchSelectHotelTemplate = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(SelectHotelTemplateQuery, { variables: { hotelID }, fetchPolicy: "network-only" });
};
